// Business page: "Set the stone" — this business's Gems with the passport redeem flow, or an unlock nudge.
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { Lock, Gem } from "lucide-react";
import { GemRedeemButton } from "../GemRedeemButton";
import { GemSvg } from "./GemSvg";
import { API } from "../../App";

export const GemRedeemPanel = ({ businessId, businessName }) => {
  const [pass, setPass] = useState(undefined);
  const [hoard, setHoard] = useState(null);
  const load = () => axios.get(`${API}/passport/me`, { withCredentials: true }).then((r) => setPass(r.data)).catch(() => setPass(null));
  useEffect(() => { load(); axios.get(`${API}/hoard/gems`).then((r) => setHoard(r.data)).catch(() => {}); }, []);
  const biz = (hoard?.businesses || []).find((b) => (businessId && b.business_id === businessId) || b.name?.toLowerCase() === (businessName || "").toLowerCase());
  if (pass === undefined || !biz?.gems?.length) return null;
  const active = pass?.status === "active";
  const tiles = (pass?.tiles || []).filter((t) => t.business_id === biz.business_id || t.business_name?.toLowerCase() === biz.name.toLowerCase());
  return (
    <section id="redeem" className="max-w-4xl mx-auto px-6 py-10" data-testid="gem-redeem-panel">
      <div className="rounded-3xl bg-[#120A24] text-white p-5 sm:p-7 ring-1 ring-[#54E3FF]/40 shadow-2xl">
        <p className="m-0 text-[10px] font-black uppercase tracking-[0.25em] text-[#9CA3AF]">THE GEM HOARD · set the stone</p>
        <h2 className="m-0 mt-1 font-['Playfair_Display'] text-2xl sm:text-3xl font-semibold">Redeem at {biz.name}</h2>
        {active ? (
          <>
            <p className="m-0 mt-2 text-sm text-[#C8F4FF]">Each Gem works once. At the counter, open it and let <b>staff</b> tap REDEEM — the stone turns gold and it's done.</p>
            <ul className="m-0 mt-4 p-0 list-none space-y-3">
              {biz.gems.map((g) => {
                const tile = tiles.find((t) => t.tile_id === g.item_id) || { tile_id: g.item_id, title: g.title, business_id: biz.business_id, business_name: biz.name, redeemed: false };
                return (
                  <li key={g.item_id} className="flex items-center gap-3 rounded-2xl bg-white/5 ring-1 ring-white/10 p-3" data-testid={`redeem-gem-${g.item_id}`}>
                    <GemSvg cut={g.cut} color={g.color} size={48} gold={tile.redeemed} title={g.stone} className="shrink-0" />
                    <div className="min-w-0 flex-1">
                      <p className="m-0 font-semibold">{g.title}</p>
                      {g.details && <p className="m-0 text-xs text-[#9CA3AF]">{g.details}</p>}
                    </div>
                    <GemRedeemButton tile={tile} business={{ business_id: biz.business_id, business_name: biz.name, business_logo: biz.logo_url }} onChange={load} />
                  </li>
                );
              })}
            </ul>
          </>
        ) : (
          <div className="mt-3 rounded-2xl bg-white/5 ring-1 ring-white/10 p-4 text-sm" data-testid="redeem-locked">
            <p className="m-0 inline-flex items-center gap-2 font-bold"><Lock className="h-4 w-4 text-[#F5D06F]" /> {biz.gems.length} Gem{biz.gems.length === 1 ? "" : "s"} waiting here for you</p>
            <p className="m-0 mt-1 text-[#C8F4FF]">Give $20 (or $5 sliding-scale) to any nonprofit on the Starflower and the whole Hoard — this and every other business's Gems — opens as our thank-you.</p>
            <Link to="/passport" className="mt-3 inline-flex items-center gap-1.5 rounded-full bg-[#54E3FF] text-[#120A24] px-4 py-2 text-sm font-black no-underline" data-testid="redeem-unlock-link"><Gem className="h-4 w-4" /> Unlock the Hoard</Link>
          </div>
        )}
      </div>
    </section>
  );
};
